<template>
  <div class="community-comment text-light">
    <b-dropdown
      variant="link"
      toggle-class="text-decoration-none text-light"
      right
      no-caret
      v-if="$user.user.id == comment.user.id"
    >
      <template v-slot:button-content>
        <i class="fas fa-ellipsis-h" />
      </template>

      <b-dropdown-item @click="$emit('edit', comment)">
        Editar
      </b-dropdown-item>
      <b-dropdown-item @click="$emit('remove', comment)">
        Remover
      </b-dropdown-item>
    </b-dropdown>

    <template v-if="!comment.parent">
      <component
        :is="link ? 'router-link' : 'div'"
        :to="{ name: 'community-topic', params: { id: comment.id } }"
        class="text-light text-decoration-none d-block"
      >
        <h5>{{ comment.title }}</h5>

        <div class="d-flex">
          <div
            :id="`popover-${comment.id}`"
            class="d-flex align-items-center mb-3 cursor-pointer"
            @click="userModal = true"
          >
            <img
              v-if="comment.user.picture"
              :src="comment.user.picture"
              class="user-picture mr-2"
            />

            <div class="d-flex flex-column overflow-hidden text-secondary">
              <h6 class="mb-0 text-light">
                {{ comment.user.name }}
              </h6>
              <small v-if="comment.category" class="text-ellipsis">
                <span class="text-secondary mr-2">{{ time }}</span>
                <img :src="comment.category.icone" class="mr-1" height="10" />
                <span class="text-light">{{ comment.category.name }} </span>
                <span v-if="comment.lesson_id">
                  | {{ comment.lesson.name }}
                </span>
              </small>
            </div>
          </div>
        </div>

        <div class="mb-2">{{ comment.text }}</div>

        <img
          v-if="comment.picture"
          class="comment-picture img-fluid mb-2"
          :src="comment.picture"
        />

        <div
          class="d-flex align-items-center justify-content-end text-secondary"
        >
          <i class="fas fa-heart mr-2"></i>
          <span>{{ likeCount }}</span>
          <i class="fas fa-comment-alt mr-2 ml-3"></i>
          <span>{{ comment.count }}</span>
        </div>

        <hr />
      </component>

      <button class="btn btn-sm btn-interact mr-2" @click="like">
        <i class="fa-heart" :class="{ fas: liked, far: !liked }"></i> Curtir
      </button>

      <button class="btn btn-sm btn-interact" @click="$emit('reply', comment)">
        <i class="far fa-comment-alt"></i> Responder
      </button>
    </template>

    <div v-else>
      <div class="d-flex">
        <div
          :id="`popover-${comment.id}`"
          class="d-flex align-items-center mb-3 cursor-pointer"
          @click="userModal = true"
        >
          <img
            v-if="comment.user.picture"
            :src="comment.user.picture"
            class="user-picture mr-2"
          />
          <div>
            <h6 class="mb-0">
              {{ comment.user.name }}
            </h6>
            <small class="text-secondary">{{ time }}</small>
          </div>
        </div>
      </div>
      <div class="mb-2">{{ comment.text }}</div>

      <button
        v-if="level < 2"
        class="btn btn-sm text-secondary"
        @click="$emit('reply', comment)"
      >
        <i class="fas fa-reply"></i> Responder
      </button>
    </div>

    <b-popover
      :target="`popover-${comment.id}`"
      triggers="hover"
      placement="bottom"
    >
      <profile-popover :user="comment.user" @open="userModal = true" />
    </b-popover>

    <b-modal v-model="userModal" hide-header hide-footer centered size="lg">
      <profile-modal :user="comment.user" />
    </b-modal>

    <comment
      v-for="child in comment.childers"
      :key="child.id"
      :comment="child"
      :level="level ? level + 1 : 1"
      class="mt-2"
      @edit="$emit('edit', child)"
      @remove="$emit('remove', child)"
      @reply="$emit('reply', child)"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import "dayjs/locale/pt";
import relativeTime from "dayjs/plugin/relativeTime";
import ProfilePopover from "./ProfilePopover";
import ProfileModal from "./ProfileModal";

dayjs.extend(relativeTime);
dayjs.locale("pt");

export default {
  components: { ProfilePopover, ProfileModal },
  name: "comment",
  props: {
    comment: Object,
    link: Boolean,
    level: Number
  },
  data() {
    return {
      liked: this.comment.liked,
      likeCount: this.comment.like,
      userModal: false
    };
  },
  computed: {
    time() {
      return dayjs().to(dayjs(this.comment.created_at).add(3, "hour"));
    }
  },
  methods: {
    like() {
      this.liked = !this.liked;
      this.$store
        .dispatch("community/interact", {
          comment_id: this.comment.id,
          like: this.liked
        })
        .then(() => {
          if (this.liked) this.likeCount++;
          else this.likeCount--;
        })
        .catch(() => {
          this.liked = !this.liked;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.community-comment {
  border-radius: 8px;
  padding: 16px 16px 10px;
  background: rgba(255, 255, 255, 0.03);
  font-size: 14px;
  position: relative;

  h6 {
    small {
      margin-left: 4px;
    }
  }

  .btn-sm {
    font-size: 12px;
  }

  ::v-deep .dropdown {
    position: absolute;
    right: 0;
    top: 0;

    .dropdown-toggle::after {
      display: none;
    }
  }

  .user-picture {
    max-height: 45px;
    max-width: 45px;
    min-height: 45px;
    min-width: 45px;
    border-radius: 45px;
  }

  .btn-interact {
    color: white;
    display: inline-flex;
    align-items: center;

    i {
      font-size: 18px;
      margin-right: 6px;
    }
  }

  hr {
    border-color: #373737;
    margin: 6px 0 12px;
  }

  .text-ellipsis {
    display: block;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .comment-picture {
    max-height: 500px;
  }
}
</style>
